module.exports = __webpack_public_path__ + "static/media/Tan-mbaTakougnadi.a430a2fa.pdf";